export const RESPONSE_REQUEST = "RESPONSE_REQUEST";
export const ERROR = "ERROR";
export const START_REQUEST = "START_REQUEST";
export const END_REQUEST = "END_REQUEST";

export const SIGNIN = "SIGNIN";
export const SIGNUP = "SIGNUP";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";




// WEBPACK FOOTER //
// ./src/actions/actionsTypes.js